import { FacebookLogo, InstagramLogo, TiktokLogo } from '@phosphor-icons/react'
import { AGENCY } from '../data/travel'
import { scrollToSection } from '../utils/scrollTo'

export default function Footer() {
  return (
    <footer className="border-t border-navy-900/10 bg-white px-4 py-12 md:px-8">
      <div className="mx-auto flex max-w-7xl flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div>
          <p className="font-display text-2xl font-extrabold tracking-tight text-navy-950">{AGENCY.name}</p>
          <p className="mt-1 text-sm text-navy-700/60">{AGENCY.tagline}</p>
        </div>

        <div className="grid grid-cols-2 gap-10 text-sm md:grid-cols-3 md:gap-16">
          <nav className="flex flex-col gap-2">
            <a href="#tours" onClick={(e) => scrollToSection(e, 'tours')} className="text-navy-700/70 hover:text-sunset-600">Tours</a>
            <a href="#paquetes" onClick={(e) => scrollToSection(e, 'paquetes')} className="text-navy-700/70 hover:text-sunset-600">Paquetes</a>
            <a href="#nosotros" onClick={(e) => scrollToSection(e, 'nosotros')} className="text-navy-700/70 hover:text-sunset-600">Nosotros</a>
            <a href="#preguntas" onClick={(e) => scrollToSection(e, 'preguntas')} className="text-navy-700/70 hover:text-sunset-600">Preguntas</a>
            <a href="#cotizador" onClick={(e) => scrollToSection(e, 'cotizador')} className="text-navy-700/70 hover:text-sunset-600">Cotizar</a>
          </nav>
          <div className="flex flex-col gap-2 text-navy-700/60">
            <p>{AGENCY.address}</p>
            <p>{AGENCY.phoneDisplay}</p>
          </div>
          <div className="flex gap-3">
            <a
              href={AGENCY.instagram}
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
              className="grid h-10 w-10 place-items-center rounded-xl border border-navy-900/10 text-navy-950 transition-colors hover:border-navy-950"
            >
              <InstagramLogo size={18} />
            </a>
            <a
              href={AGENCY.facebook}
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
              className="grid h-10 w-10 place-items-center rounded-xl border border-navy-900/10 text-navy-950 transition-colors hover:border-navy-950"
            >
              <FacebookLogo size={18} />
            </a>
            <a
              href={AGENCY.tiktok}
              aria-label="TikTok"
              target="_blank"
              rel="noopener noreferrer"
              className="grid h-10 w-10 place-items-center rounded-xl border border-navy-900/10 text-navy-950 transition-colors hover:border-navy-950"
            >
              <TiktokLogo size={18} />
            </a>
          </div>
        </div>
      </div>
      <p className="mx-auto mt-12 max-w-7xl text-xs text-navy-700/40">
        &copy; {new Date().getFullYear()} Despega GT. Todos los derechos reservados.
      </p>
    </footer>
  )
}
